<template lang="pug">
  SplitLayout
    DrugInfo(slot="left")
    div(slot="right")
      ConfirmFlow(
        v-if="currentProgress === 'confirm'"
        v-on:confirmationFinish="getConfirmData" 
        :confirmProgress="confirmProgress"
      )
      Loader(v-if="currentProgress === 'finish'")
</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import DrugInfo from '../flowComp/DrugInfo';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';
import SplitLayout from '../SplitLayout';

export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  data() {
    return {
    };
  },
  components: {
    DrugInfo,
    ConfirmFlow,
    Loader,
    SplitLayout,
  },
  async created() {
    console.log('create');
    await this.$store.dispatch('fromFirstDrugInDevice');
    console.log('created');
  },
  methods: {
    async getConfirmData() {
      this.nextProgress();
      if (this.nextDrugInDevice !== null) {
        // check whether next index is over the keys' array length
        console.log('get confirm data');
        await this.$store.dispatch('toNextDrugInDevice');
        this.resetProgress();
      } else {
        console.log('leave multiflow');
        this.$emit('setAllConfirmData');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?71b795de